import styled from 'styled-components';
import { Button } from 'reactstrap';
import Switch from 'react-bootstrap-switch';
import { color } from '../../assets/styles/colors';

export const ButtonAprovar = styled(Button)`
	background-color: ${color.yellow};
	border-radius: 50;
`;

export const TrStyled = styled.tr`
	background: ${color.primary};
	color: ${color.black} !important;

	th {
		text-align: center;
		//padding: 10px !important;

		&:not(:last-child) {
			border-right: 1px solid ${color.black} !important;
		}

		&::after {
			width: 0 !important;
		}
	}
`;

export const SwitchCss = styled(Switch)`
`;

export const ButtonAutorizar = styled(Button)`
	min-height: 30px;
	border: 2px solid #FA6159;
	border-top-left-radius: 14px;
	border-bottom-left-radius: 14px;

	font-weight: 400;
	font-size: 12px;
	line-height: 100%;
`;

export const ButtonReprovar = styled(Button)`
	min-height: 30px;
	border: 2px solid #FA6159;
	border-top-right-radius: 14px;
	border-bottom-right-radius: 14px;

	font-weight: 400;
	font-size: 12px;
	line-height: 100%;
`;

